<template>
    <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M40.1705 6C41.8274 6 43.1705 4.65685 43.1705 3C43.1705 1.34315 41.8274 4.29153e-06 40.1705 4.29153e-06V6ZM40.1705 73.7102C21.4729 73.7102 6.31543 58.5528 6.31543 39.8551H0.315434C0.315434 61.8665 18.1592 79.7102 40.1705 79.7102L40.1705 73.7102ZM6.31543 39.8551C6.31543 21.1574 21.4729 6 40.1705 6V4.29153e-06C18.1592 4.29153e-06 0.315434 17.8437 0.315434 39.8551H6.31543Z"
            fill="url(#paint0_linear_26_1813)"
        />
        <path
            d="M77.0254 39.8554C77.0254 19.5009 60.5248 3.00027 40.1703 3.00027"
            stroke="var(--theme-selectable-accent-color, #276CE1)"
            stroke-width="6"
            stroke-linecap="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_26_1813"
                x1="40.1705"
                y1="1.33986"
                x2="40.1705"
                y2="74.386"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="var(--theme-selectable-accent-color, #276CE1)" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "LoadingIcon",
};
</script>
